import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.bbs.message;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,

    DELETE_ASYNC: `${uid}.deleteAsync`,
    DELETE_SUCCESS: `${uid}.deleteSuccess`,
    DELETE_FAILURE: `${uid}.deleteFailure`,

    LIKE_ASYNC: `${uid}.likeAsync`,
    LIKE_SUCCESS: `${uid}.likeSuccess`,
    LIKE_FAILURE: `${uid}.likeFailure`,

    DELETE_LIKE_ASYNC: `${uid}.deleteLikeAsync`,
    DELETE_LIKE_SUCCESS: `${uid}.deleteLikeSuccess`,
    DELETE_LIKE_FAILURE: `${uid}.deleteLikeFailure`,

    REPLY_ASYNC: `${uid}.replyAsync`,
    REPLY_SUCCESS: `${uid}.replySuccess`,
    REPLY_FAILURE: `${uid}.replyFailure`,

    SET_MESSAGE_ID: `${uid}.setMessageId`,
};

export { ActionTypes };
